/** Отсутствие безопасного генератора остаётся явным результатом для вызывающего. */
export function createBrowserUuid(): string | null {
  if (typeof globalThis.crypto === 'undefined' || typeof globalThis.crypto.randomUUID !== 'function') {
    return null;
  }

  return globalThis.crypto.randomUUID();
}
